import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import ViewOffer from "./ViewOffer";
import MarginOffer from "./MarginOffer";
import GenerateOffer from "./GenerateOffer";
import CreateOffers from "./CreateOffers";
import CreateOffersManual from "./CreateOffersManual";
import GTPOffer from "./GTPOffer";

const AmtplOffers = () => {
  const [activeTab, setActiveTab] = useState("View Offer");
  const tabs = [
    "View Offer",
    "Margin Change Request",
    "Global Partner Offer",
    "Generate Offer",
    "Create Offers (Bulk)",
    "Create Offers",
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "View Offer":
        return <ViewOffer />;
      case "Margin Change Request":
        return <MarginOffer />;
      case "Global Partner Offer":
        return <GTPOffer />;
      case "Generate Offer":
        return <GenerateOffer />;
      case "Create Offers (Bulk)":
        return <CreateOffers />;
      case "Create Offers":
        return <CreateOffersManual />;
      default:
        return <ViewOffer />; // Added return statement
    }
  };

  return (
    <div className="buyer-layout card">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AmtplOffers;
